import { createApi } from "@reduxjs/toolkit/query/react";
import { User } from "../../models/user";
import { QueryArg, axiosBaseQuery } from "../axiosConfig";
import { RequestMethod } from "../enum";
import { transformUser } from "./helpers";
import { GetUsersArgs } from "./types";

const getUsers = (args: GetUsersArgs): QueryArg => ({
  url: "",
  method: RequestMethod.GET,
  params: args,
});

export const usersApi = createApi({
  reducerPath: "usersApi",
  baseQuery: axiosBaseQuery({
    baseUrl: "/users",
  }),
  tagTypes: ["Users"],
  endpoints: (build) => ({
    getUsers: build.query<User[], GetUsersArgs | void>({
      query: getUsers,
      transformResponse: ({ users = [] }: { users: User[] }) => users.map(transformUser),
      providesTags: ["Users"],
    }),
  }),
});
